import { renderEmptyTrashBinDialog } from 'reactApp/components/EmptyTrashBin/EmptyTrashBin.helpers';

export const clear = (): void => {
    renderEmptyTrashBinDialog();
};
